module.exports = {
      id: "share-usage",
      viewBox: "0 0 41 41",
      url: __webpack_public_path__ + "svg-sprite-3da3c54197bd9bf6e26a7217bd920efb.svg#share",
      toString: function () {
        return this.url;
      }
    }